module.exports = __webpack_public_path__ + "static/media/menu.68a8ab43.svg";